import { render, staticRenderFns } from "./Office365AuthResponse.vue?vue&type=template&id=24b28826&scoped=true"
import script from "./Office365AuthResponse.vue?vue&type=script&lang=js"
export * from "./Office365AuthResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b28826",
  null
  
)

export default component.exports